import { combineReducers } from 'redux';

import {
    REQUEST_UPDATE_PASSWORD,
    SUCCESS_UPDATE_PASSWORD,
    FAILURE_UPDATE_PASSWORD,
    RESET_FORM_SUBMIT_UPDATE_PASSWORD
} from './constants';

const successPasswordUpdate = (state = false, action) => {
    switch (action.type) {
        case SUCCESS_UPDATE_PASSWORD:
            return true;
        case REQUEST_UPDATE_PASSWORD:
        case FAILURE_UPDATE_PASSWORD:
        case RESET_FORM_SUBMIT_UPDATE_PASSWORD:
            return false;
        default:
            return state;
    }
};

const fetching = (state = false, action) => {
    switch (action.type) {
        case REQUEST_UPDATE_PASSWORD:
            return true;
        case FAILURE_UPDATE_PASSWORD:
        case SUCCESS_UPDATE_PASSWORD:
        case RESET_FORM_SUBMIT_UPDATE_PASSWORD:
            return false;
        default:
            return state;
    }
};

const error = (state = '', action) => {
    switch (action.type) {
        case FAILURE_UPDATE_PASSWORD:
            return action.response.message;
        case REQUEST_UPDATE_PASSWORD:
        case SUCCESS_UPDATE_PASSWORD:
        case RESET_FORM_SUBMIT_UPDATE_PASSWORD:
            return '';
        default:
            return state;
    }
};

export default combineReducers({
    successPasswordUpdate,
    fetching,
    error
});



// WEBPACK FOOTER //
// ./src/services/account/password/reducer.js